import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22font-family.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../assets/fonts/officina.woff2%22,%22adjustFontFallback%22:%22Arial%22,%22weight%22:%22500%22,%22variable%22:%22--font-headline%22}],%22variableName%22:%22headlineFontLoader%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'headlineFontLoader', 'headlineFontLoader Fallback'",
        fontWeight: 500,

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
